import { isEmpty, isNull } from "lodash";
import {
  renderNull,
  renderRiskClassName,
  getDataSourceIcon,
} from "../Dashboard/ContentPages/SysGuardColumnConfig";
import { useSelector } from "react-redux";
import { maskUsername, userTimeZone } from "../SysGuardCommonComp";
import moment from "moment";
import { Chip } from "@material-ui/core";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import Tooltip from "@material-ui/core/Tooltip";

export const attemptStatusIcons = {
  LOGIN_SUCCESS: <CheckCircleIcon style={{ color: "green" }} />,
  LOGIN_FAILURE: <CancelIcon style={{ color: "red" }} />,
};

const renderLocationWithRisk = (params) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    return (
      <div className={renderRiskClassName(params.row.countryRisk)}>
        {params.value}
      </div>
    );
  }
};

const RenderUserName = (params) => {
  const isIncognito = useSelector((state) => state.SysGuardReducer.incognito);
  if (isNull(params.value) || isEmpty(params.value)) {
    return <div className="sys-guard-status">Unknown</div>;
  } else if (isIncognito) {
    return <div className="sys-guard-status">{maskUsername(params.value)}</div>;
  } else {
    return (
      <div className="sys-guard-status" title={params.value}>
        {params.value}
      </div>
    );
  }
};

const RenderDataSourceChip = (params) => {
  const sysGuardDataSource = useSelector(
    (state) => state.SysGuardReducer.sysGuardDataSource,
  );
  const datasourceId = params.row?.dataSourceId;

  if (!datasourceId) {
    return renderNull();
  }

  const ds = sysGuardDataSource?.[datasourceId];

  if (!ds) {
    return renderNull();
  }

  return (
    <Chip
      title={ds?.domainName}
      icon={
        <img
          src={getDataSourceIcon(ds?.typeCode)}
          alt={ds?.typeName}
          className="data-source-chip-icon"
        />
      }
      label={ds?.domainName}
      className="data-source-chip"
      size="small"
    />
  );
};

const renderClientIp = (params) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    return (
      <div className="sys-guard-client-ip" title={params.value}>
        {params.value}
      </div>
    );
  }
};

const renderName = (params) => {
  if (isNull(params.value) || isEmpty(params.value)) {
    return <div>Unknown</div>;
  } else {
    return (
      <div className="sys-guard-status" title={params.value}>
        {params.value}
      </div>
    );
  }
};

const renderStatusHeader = () => {
  return (
    <div className="sys-guard-attempt-status-header" title="Attempted Status">
      Attempted Status
    </div>
  );
};

const renderDateWitTimeZone = (title) => {
  return (
    <div
      className="sys-guard-date-status-header"
      title={`${title} (${userTimeZone})`}
    >
      <span>{title}</span>
      <span className="timeZone">({userTimeZone})</span>
    </div>
  );
};

const renderStatus = (params, loc) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    const row = params?.row;

    return (
      <Tooltip
        title={
          <div className="custom-tooltip-content">
            {loc !== "failure" ? (
              <>
                <div>
                  <strong>Device:</strong>{" "}
                  <span>{row?.deviceOs || "Unknown"}</span>
                </div>
                <div>
                  <strong>Browser:</strong>{" "}
                  <span>{row?.browser || "Unknown"}</span>
                </div>
              </>
            ) : null}
            {row?.actionPerformed === "LOGIN_SUCCESS" ? (
              <div>
                <strong>Login:</strong> <span>success</span>
              </div>
            ) : (
              <div>
                <strong>Error:</strong>{" "}
                <span>{row?.failureReason || "Unknown reason"}</span>
              </div>
            )}
          </div>
        }
        placement="top"
        arrow
        classes={{
          tooltip: "custom-tooltip-popup",
          arrow: "custom-arrow-popup",
        }}
      >
        <div className="sys-guard-status">
          {attemptStatusIcons[params.value]}
        </div>
      </Tooltip>
    );
  }
};

export const userLocationColumns = [
  {
    field: "date",
    flex: 1.5,
    align: "center",
    headerAlign: "center",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    headerName: "Time",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "location",
    headerName: "City",
    flex: 3.5,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderLocationWithRisk(params),
  },
  {
    field: "clientIp",
    headerName: "IP Address",
    flex: 2.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderClientIp(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1.3,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params),
    renderHeader: () => renderStatusHeader(),
  },
];

export const userDeviceColumns = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "deviceName",
    headerName: "Device Name",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "deviceOs",
    headerName: "Device OS",
    flex: 1,
    align: "left",
    headerAlign: "left",
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params),
    renderHeader: () => renderStatusHeader(),
  },
];

export const userAnomaliesColumn = [
  {
    field: "date",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "policyName",
    headerName: "Policy",
    flex: 4,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
];

export const userApplicationsColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.2,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "appName",
    headerName: "Application",
    flex: 2.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "deviceName",
    headerName: "Device Name",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params),
    renderHeader: () => renderStatusHeader(),
  },
];

export const locationBasedUsersColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderUserName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "clientIp",
    headerName: "IP Address",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderClientIp(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params),
    renderHeader: () => renderStatusHeader(),
  },
];

export const locationBasedAnomaliesColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderUserName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "clientIp",
    headerName: "IP Address",
    flex: 2,
    align: "left",
    headerAlign: "left",
  },
];

export const userBasedFailurePercentageColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.6,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "location",
    headerName: "location",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "deviceOs",
    headerName: "Device",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "browser",
    headerName: "Browser",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params, "failure"),
    renderHeader: () => renderStatusHeader(),
  },
];

export const applicationBasedFailurePercentageColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.6,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "city",
    headerName: "City",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.2,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "deviceOs",
    headerName: "Device",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params, "failure"),
    renderHeader: () => renderStatusHeader(),
  },
];

export const locationBasedFailurePercentageColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.6,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "city",
    headerName: "City",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.2,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "deviceOs",
    headerName: "Device",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
 {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params, "failure"),
    renderHeader: () => renderStatusHeader(),
  },
];

export const cityBasedFailurePercentageColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.6,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.2,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "deviceOs",
    headerName: "Device",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
 {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params, "failure"),
    renderHeader: () => renderStatusHeader(),
  },
];

export const locationBasedApplicationColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "appName",
    headerName: "Application",
    flex: 2,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.7,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderUserName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params),
    renderHeader: () => renderStatusHeader(),
  },
];

export const applicationBasedUsersColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderUserName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "deviceName",
    headerName: "Device Name",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params),
    renderHeader: () => renderStatusHeader(),
  },
];

export const applicationBasedAnomaliesColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderUserName(params),
  },
  {
    field: "dataSource",
    headerName: `Domain`,
    flex: 2,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
];
